// Site selector component for manager views
// CREATED: Dropdown with consistent styling matching MultiProfileSelector
// UPDATED: Refactored to use BaseFilterDropdown for consistency
// UPDATED: Integrated search bar for filtering sites by name
// UPDATED: Added "Clear All" button in header (visible when item selected)
// Provides unified interface for site selection across all manager views

import { MapPin } from 'lucide-react';
import { BaseFilterDropdown } from '../ui/BaseFilterDropdown';

interface SiteInfo {
  id: string;
  name: string;
}

interface SiteSelectorProps {
  sites: SiteInfo[];
  selectedSiteId: string | null;
  onSiteChange: (siteId: string) => void;
  compact?: boolean;
}

export function SiteSelector({
  sites,
  selectedSiteId,
  onSiteChange,
  compact = false
}: SiteSelectorProps) {
  // Convert single selection to array format for BaseFilterDropdown
  const selectedSiteIds = selectedSiteId ? [selectedSiteId] : [];

  const handleSelectionChange = (siteIds: string[]) => {
    if (siteIds.length > 0) {
      onSiteChange(siteIds[0]);
    }
  };

  return (
    <BaseFilterDropdown
      items={sites}
      selectedItems={selectedSiteIds}
      onSelectionChange={handleSelectionChange}
      getItemId={(site) => site.id}
      getItemLabel={(site) => site.name}
      label="Site"
      icon={compact ? <MapPin size={16} /> : undefined}
      placeholder="Sélectionner un site"
      emptyMessage="Aucun site disponible"
      singleSelection={true}
      compact={compact}
      searchable={true}
      searchPlaceholder="Rechercher un site..."
      showSelectAll={false}
      showFooter={false}
      filterItem={(site, query) => {
        return site.name.toLowerCase().includes(query.toLowerCase());
      }}
      renderOption={(site, isSelected) => (
        <div className="flex items-center gap-3 flex-1">
          <MapPin
            size={16}
            className={isSelected ? 'text-primary-600' : 'text-gray-400'}
          />
          <span className={`text-sm ${isSelected ? 'text-primary-600 font-medium' : 'text-gray-700'}`}>
            {site.name}
          </span>
        </div>
      )}
    />
  );
}
